import { ChangeDetectionStrategy, Component } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import dxSelectBox from 'devextreme/ui/select_box';
import { User } from 'shared';
import { LayoutService } from '../home/layout.service';
import { Campaign, CampaignService } from '../stores/campaign.service';
import { FieldCropService } from '../stores/field-crop.service';

@Component({
  selector: 'app-fields-crops-grid',
  templateUrl: './fields-crops-grid.component.html',
  styleUrls: ['./fields-crops-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})

export class FieldsCropsGridComponent {
  public fieldCropDs: DataSource;

  private viewSelectionBox: dxSelectBox;
  public campaignDs: DataSource;
  public currentCampaign: number;

  public canEdit: boolean;
  public canAdd: boolean;
  public canDelete: boolean;

  constructor(
    private fieldCropService: FieldCropService,
    private layoutService: LayoutService,
    public user: User,
    private campaignService: CampaignService
  ) {
    // Bindings
    this.openEditor = this.openEditor.bind(this);

    // Fetch campaigns and update viewSelectionBox
    this.campaignDs = campaignService.newDataSource();

    this.campaignDs.load().then((campaigns) => {
      campaigns.forEach((val) => {
        if (val.is_current) {
          val.name = val.name + " (Actual)"

          this.currentCampaign = val.id;
        };
      });

      this.campaignDs.items().unshift({ id: 0, name: "toutes", is_current: false, is_selected: false } as Campaign)
      this.viewSelectionBox.option("items", campaigns);
      this.viewSelectionBox.option("value", this.currentCampaign);
      this.viewSelectionBox.option("disabled", false);

      // Data fields' crops
      this.fieldCropDs = fieldCropService.newDataSource({
        filter: [
          ['campaign_id', '=', this.currentCampaign]
        ]
      });
    });

    // Permissions
    this.canEdit = user.can('edit crops');
    this.canAdd = user.can('add crops');
    this.canDelete = user.can('delete crops');
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.splice(e.toolbarOptions.items.length - 5, 0, {
      location: 'after',
      widget: 'dxSelectBox',
      options: {
        hint: 'sélectionner la campagne',
        valueExpr: 'id',
        displayExpr: 'name',
        icon: 'box',
        disabled: true,
        onInitialized: (ee) => {
          this.viewSelectionBox = ee.component;
        },
        onItemClick: (ee) => {
          if (!ee.itemData.id) {
            this.fieldCropDs.filter("");
          } else {
            this.fieldCropDs.filter([
              ['campaign_id', '=', ee.itemData.id as number]
            ]);
          }

          // We need to reload the ds
          this.fieldCropDs.reload();
        }
      }
    });
  }

  openEditor(e: any) {
    this.layoutService.openTab({
      id: 'field-editor-' + e.row.data.id,
      type: 'component',
      title: 'Editeur Culture ' + e.row.data.name,
      componentName: 'field-editor',
      componentState: {
        crop: e.row.data,
      }
    });
  }
}
